module.exports = __webpack_public_path__ + "static/media/main-logo.ce952181.svg";